import React from "react";
import * as ReactDOMClient from "react-dom/client";
import App from "./App";
import { MaterialUIControllerProvider } from "./context";
import { BrowserRouter } from "react-router-dom";
import AuthContextProvider from "./context/AuthContext/AuthContextProvider";
import LoadingContext from "./context/LodingContext";
import SuccessContext from "./context/SucccessContext";
import ErrorContext from "./context/ErrorContext";
//Redux config
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { store, persistor } from "./Redux/store";
// import VendorDataContext from './lib/apiHooks/VendorContext';

const container = document.getElementById("root");
const root = ReactDOMClient.createRoot(container);
console.log = () => {};
console.warn = () => {};

root.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
  <BrowserRouter>
    <MaterialUIControllerProvider>
      <AuthContextProvider>
        <SuccessContext>
          <ErrorContext>
            <LoadingContext>
              <App />
            </LoadingContext>
          </ErrorContext>
        </SuccessContext>
        {/* <  VendorDataContext> */}

        {/* </VendorDataContext> */}
      </AuthContextProvider>
    </MaterialUIControllerProvider>
  </BrowserRouter>
  </PersistGate>
  </Provider>
);
